import { Link } from "gatsby"
import PropTypes from "prop-types"
import React from "react"
import Twemoji from "react-twemoji"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faGithub } from "@fortawesome/free-brands-svg-icons"

const Header = ({ siteTitle }) => (
  <header className="bg-blue-300 mb-5 h-20">
    <div className="py-6 container mx-auto">
      <h1 className="float-left ml-6 font-bold">
        <Link className="no-underline text-white text-lg" to="/">
          {siteTitle} <Twemoji className="inline-block">🐈</Twemoji>
        </Link>
      </h1>
      <div className="float-right mr-8">
        <a href="https://github.com/kenzoukenzou">
          <FontAwesomeIcon className="text-white" icon={faGithub} size="2x" />
        </a>
      </div>
    </div>
  </header>
)

Header.propTypes = {
  siteTitle: PropTypes.string,
}

Header.defaultProps = {
  siteTitle: `my own pace...`,
}

export default Header
